module.exports = __webpack_public_path__ + "media/images/clients/ring-6128c70f2afc1b18c4d6b88407846c99.svg";